import api from './api';

const openQuestionLibraryAPI = {
  getQuestions: (params = {}) => api.get('/open-question-library/questions', { params }),
  getQuestion: (id) => api.get(`/open-question-library/questions/${id}`),
  getFacets: (params = {}) => api.get('/open-question-library/facets', { params }),
  review: (data) => api.post('/open-question-library/questions/review', data),
  deliver: (data) => api.post('/open-question-library/deliveries', data)
};

export default openQuestionLibraryAPI;
